<template>
    <div id='blog' style='overflow: auto; height: 100%'>
        <div class='container'>
            <h3>Thank you!</h3>
            <p>You can read our latest experiences below. Hope you enjoy the content. Feel free to write to us, we love to hear from you.</p>

            <div class='row'>
                <div class='col-md-4 post' v-for="post in posts" :key="post.id">
                    <div class='card'>
                        <div :style="imageStyle(post)" class='card-img-top' @click="showPost(post)" /> 
                        <div class='card-body'>
                            <h5 class='card-title' @click="showPost(post)">{{ post.title }}</h5>
                            <p class='card-text'>{{ post.excerpt }}...</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import GhostContentAPI from '@tryghost/content-api'

export default {
    name: 'blog',
    
    data() {
        return {posts: []}
    },

    mounted(){  
        const api = new GhostContentAPI({
            url: 'https://runawayrascals.com',
            key: '601c7443caa7eb02dc87c19568',
            version: 'v2'
        });

        api.posts.browse({limit: 6}).then(posts => this.posts = posts);
    },

    methods: {
        showPost(post){
            window.location = post.url;
        },

        imageStyle(post){
            return {
                backgroundImage: `url(${post.feature_image})`,
                height: "250px",
                backgroundPosition: "center",
                backgroundSize: "cover",
                border: 0,
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    #blog {
        .container {
            padding-top: 40px;
            padding-bottom: 40px;
            .card-img-top {cursor: pointer;}
            .card-title {cursor: pointer;}
        }
    }

    @media (max-width: 767.98px) { 
        #blog  {
            .container {
                padding-top: 20px;

                .post {margin-top: 16px}
                .post:first-child {margin-top: 0px}
            }
        }
        
    }
</style>